
<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <div
      slot="header"
      class="flex flex-wrap-reverse items-center flex-grow justify-between w-full mx-4"
    >
      <vs-col vs-lg="12 p-5 pl-0" vs-sm="12">
        <vs-row>
          <vs-dropdown>
            <vs-button
              class="ml-0 pr-5 font-semibold"
              type="filled"
              icon="expand_more"
              :color="actionBtnClr"
              icon-after
              >Action</vs-button
            >
            <vs-dropdown-menu class="viewDropdown">
              <vs-dropdown-item @click="confirmDelete = true">
                Delete
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <vs-button
            class="pl-4 ml-4"
            type="border"
            icon-pack="feather"
            icon="icon-plus"
            @click="addNewData"
            >Add Issuer</vs-button
          >
          <vs-button
            class="pl-4 ml-4"
            type="border"
            icon-pack="feather"
            icon="icon-plus"
            @click="editCard('')"
            >Add Card</vs-button
          >
        </vs-row>
      </vs-col>
    </div>

    <div
      class="shadow-lg tblBgClr mx-4"
      :key="index"
      v-for="(row, index) in cardsList"
    >
      <vs-table
        :multiple="row.cards[0].name ? true : false"
        v-model="selected[index]"
        :max-items="itemsPerPage"
        :data="row.cards"
        class="p-4"
        hoverFlat
      >
        <div slot="header" class="w-full p-0 mb-0">
          <vs-row vs-justify="space-between">
            <div>
              <div
                class="issuerCircle mb-1"
                :style="{
                  'background-color': row.cards[0].issuer_detail[0]
                    ? row.cards[0].issuer_detail[0].color
                    : '#4B4BF9',
                }"
              ></div>
              <div class="mb-4 verticalAlign ml-4 font-semibold displayInline">
                {{ row._id[0] }}
              </div>
              <div
                class="mb-4 verticalAlign ml-4 ruleHead mt-1 font-semibold displayInline"
                @click="setIssuerRuleStatus(row)"
              >
                Active Rules ({{
                  row.cards[0].issuer_detail[0].activeRulesCount
                    ? row.cards[0].issuer_detail[0].activeRulesCount
                    : 0
                }})
              </div>
            </div>
            <div>
              <vs-button
                class="mr-3"
                @click="deleteIssr(row.cards[0].issuer_detail[0]._id)"
                >Delete</vs-button
              >
              <vs-button @click="editIssuer(row)">Edit</vs-button>
            </div>
          </vs-row>

          <vs-row v-show="!row.cards[0].name" vs-justify="center">
            <h5 class="mt-3">No Cards Available</h5>
          </vs-row>
        </div>

        <template slot="thead" v-if="row.cards[0].name">
          <vs-th>IMAGE</vs-th>
          <vs-th sort-key="name">CREDIT CARD NAME</vs-th>
          <vs-th sort-key="category">ANNUAL FEES</vs-th>
          <vs-th sort-key="popularity">POINTS</vs-th>
          <vs-th sort-key="order_status">ACTIVE RULES</vs-th>
        </template>

        <template slot-scope="{ data }" v-if="row.cards[0].name">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in row.cards">
              <vs-td
                class="img-container"
                @click.native.stop="viewDetails(tr._id)"
              >
                <vue-load-image>
                  <img
                    slot="image"
                    :src="
                      tr.photo
                        ? $ApiKeys.BASE_URL + tr.photo
                        : require('@/assets/images/default-images/default-profile.png')
                    "
                    width="77"
                    height="48"
                  />
                  <img
                    slot="preloader"
                    src="@/assets/images/image-loader.gif"
                    width="77"
                    height="77"
                  />
                  <div slot="error">
                    <img
                      slot="image"
                      :src="require('@/assets/images/no_preview.jpg')"
                      width="77"
                      height="48"
                    />
                  </div>
                </vue-load-image>
              </vs-td>

              <vs-td @click.native.stop="viewDetails(tr._id)">
                <p class="font-medium truncate">{{ tr.name }}</p>
              </vs-td>

              <vs-td @click.native.stop="viewDetails(tr._id)">
                <p class="ml-6 pl-6">{{ tr.annual_fee }}</p>
              </vs-td>

              <vs-td @click.native.stop="viewDetails(tr._id)">
                <p
                  v-if="
                    tr.points_categories && tr.points_categories.length == 0
                  "
                >
                  Not Available
                </p>
                <p
                  v-if="tr.points_categories"
                  :key="index"
                  v-for="(category, index) in tr.points_categories"
                >
                  {{ category.multiplier }} x
                  {{ category.points_category[0].name }}
                </p>
              </vs-td>

              <vs-td @click.native.stop="viewDetails(tr._id)">
                <p class="ml-6 pl-6">
                  {{ tr.active_rules_check ? "YES" : "NO" }}
                </p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>

      <div
        class="flex flex-wrap-reverse items-center flex-grow py-5 mb-3 borderTop mx-5 mt-3"
      >
        <router-link
          :to="{
            name: 'add card',
            params: { issuerInfo: row.cards[0].issuer_detail[0] },
          }"
          style="color: white"
          ><PlusSquareIcon
        /></router-link>
        <router-link
          :to="{
            name: 'add card',
            params: { issuerInfo: row.cards[0].issuer_detail[0] },
          }"
          ><h5 class="ml-2">Add Card</h5></router-link
        >
      </div>
    </div>
    <vs-row>
      <vs-row>
        <vs-popup
          class="holamundo details"
          :title="cardInfo.name"
          :active.sync="showDetails"
        >
          <img :src="$ApiKeys.BASE_URL + cardInfo.photo" class="title-icon" />
          <vs-row>
            <vs-row class="detailsBorder p-4">
              <vs-col vs-lg="6">
                <p class="detailLabel pt-1">Issuer</p>
                <p class="detailContent pb-1">
                  {{ cardInfo ? cardInfo.issuer.name : "Not Available" }}
                </p>
                <p class="detailLabel pt-1">Card</p>
                <p class="detailContent pb-1">
                  {{ cardInfo ? cardInfo.name : "Not Available" }}
                </p>
                <p class="detailLabel pt-1">Product Change</p>
                <p class="detailContent pb-1">
                  {{
                    cardInfo.product_change
                      ? cardInfo.product_change.name
                      : "Not Available"
                  }}
                </p>
                <vs-row class="inputContainer p-0">
                  <vs-checkbox
                    v-model="cardInfo.five_twenty_four"
                    vs-name="rule-type"
                    :vs-value="true"
                    class="m-2 mt-5 ml-0"
                    :disabled="true"
                  />
                  <div class="detailContent pt-5">Counts toward Chase 5/24</div>
                </vs-row>
              </vs-col>
              <vs-col vs-lg="6">
                <p class="detailLabel pt-1">Card Type</p>
                <p class="detailContent pb-1">
                  {{
                    cardInfo.card_type ? cardInfo.card_type : "Not Available"
                  }}
                </p>
                <p class="detailLabel pt-1">Upgrade Card</p>
                <p class="detailContent pb-1">
                  {{
                    cardInfo.upgrade_card
                      ? cardInfo.upgrade_card.name
                      : "Not Available"
                  }}
                </p>
                <p class="detailLabel pt-1">Downgrade Card</p>
                <p class="detailContent pb-1">
                  {{
                    cardInfo.downgrade_card
                      ? cardInfo.downgrade_card.name
                      : "Not Available"
                  }}
                </p>
              </vs-col>
            </vs-row>
            <vs-row class="detailsBorder p-4">
              <vs-col vs-lg="6">
                <p class="detailLabel pt-1">Annual Fee</p>
                <p class="detailContent pb-1">${{ cardInfo.annual_fee }}</p>
                <!-- <p class="detailLabel pt-1">Effective Fee Description</p>                               
                                <p v-if="cardInfo.effective_fee_description" class="detailContent pt-1" v-html="cardInfo.effective_fee_description"></p>
                                <p class="detailContent pt-1" v-else>Not Available</p> -->
              </vs-col>
              <vs-col vs-lg="6">
                <p class="detailLabel">Points</p>
                <p
                  class="detailContent"
                  v-if="
                    cardInfo.points_categories &&
                    cardInfo.points_categories.length == 0
                  "
                >
                  Not Available
                </p>
                <p
                  class="detailContent"
                  v-if="cardInfo.points_categories"
                  :key="index"
                  v-for="(category, index) in cardInfo.points_categories"
                >
                  {{ category.multiplier }} x
                  {{ category.points_category.name }}
                </p>
              </vs-col>
            </vs-row>
            <vs-row class="p-4">
              <vs-col
                v-if="cardInfo.activeRules && cardInfo.activeRules.length > 0"
              >
                <vs-row class="mb-2">
                  <img
                    :src="require('@/assets/images/active-rules/scale.png')"
                    class="rulesIcon mr-2"
                  />
                  <p class="detailLabel">Active Rules</p>
                </vs-row>
                <div
                  class="ml-6"
                  :key="ruleIndex"
                  v-for="(rule, ruleIndex) in cardInfo.activeRules"
                >
                  <p class="p-2 whiteText font-semibold" v-if="rule.rule">
                    {{ rule.rule.name }}
                  </p>
                  <div class="p-2 pt-0 whiteText" v-if="rule.rule">
                    {{ rule.rule.description }}
                  </div>
                </div>
              </vs-col>
              <vs-col
                v-if="cardInfo.activeRules && cardInfo.activeRules.length == 0"
              >
                <p class="detailLabel">No Active Rules</p>
              </vs-col>
            </vs-row>
            <vs-row vs-justify="center" v-show="cardInfo">
              <vs-button class="font-semibold" @click="editCard(cardInfo)"
                >Edit Card Details</vs-button
              >
            </vs-row>
          </vs-row>
        </vs-popup>
      </vs-row>
      <vs-popup
        class="holamundo addIssuer"
        title="Add Issuer"
        :active.sync="showAddIssuer"
      >
        <vs-row vs-justify="space-between" class="p-5">
          <vs-col vs-lg="8" vs-sm="12" id="issuerName">
            <vs-row>
              <div class="ml-1 my-1">
                Issuer Name
                <span v-if="errors.issuerName.success" class="sterik">*</span>
                <span v-if="!errors.issuerName.success">*</span>
              </div>
            </vs-row>
            <vs-input
              placeholder="Issuer Name"
              v-model="issuer.name"
              :danger="errors.issuerName.success"
              :danger-text="errors.issuerName.msg"
              @input="validateIssuerName($event)"
              maxLength="30"
              class="w-full"
            />
          </vs-col>
          <vs-col vs-lg="4" vs-sm="12" v-if="showAddIssuer">
            <div class="my-1 marginl-0 pl-0">Issuer Color</div>
            <div
              id="issrDrop"
              class="dropbtn marginl-0 mt-1"
              @click="toggleColorList = !toggleColorList"
              v-on-clickaway="closeColorList"
              :style="{ 'background-color': issuer.color }"
            ></div>
            <div id="issrDrop" class="dropdown mt-1 pl-0">
              <div class="dropdown-content" v-show="toggleColorList">
                <div
                  class="colorItemContainer"
                  @click="issuer.color = issr.color"
                  :key="index"
                  v-for="(issr, index) in issuersList"
                >
                  <div
                    class="colorIconStyle"
                    :style="{ 'background-color': issr.color }"
                  ></div>
                  <span class="colorTextStyle">{{ issr.name }}</span>
                </div>
              </div>
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="">
          <vs-row>
            <vs-col vs-lg="3" vs-sm="3" class="pl-2">
              <div class="my-1 ml-0 pl-0 pl-4">Bonus Time (Days)</div>
              <vs-input-number
                v-model="issuer.bonus_time"
                class="inline-flex m-6"
                min="0"
              />
            </vs-col>
            <vs-col vs-lg="3" vs-sm="3">
              <div class="my-1 ml-0 pl-4">Grace Time (Days)</div>
              <vs-input-number
                v-model="issuer.grace_time"
                class="inline-flex m-6"
                min="0"
              />
            </vs-col>
          </vs-row>
          <vs-row>
            <h3 class="p-5 pb-2">Active Rules</h3>
          </vs-row>
          <vs-row>
            <p class="p-5">Do you want to add active rules for this Issuer?</p>
          </vs-row>
          <vs-row v-if="errors.rules.success">
            <p class="p-5 py-3 dangerColor">{{ errors.rules.msg }}</p>
          </vs-row>
          <vs-row>
            <vs-radio
              v-model="issuer.activeRulesCheck"
              vs-name="rule"
              vs-value="Yes"
              class="m-5"
              @change="updateRule('Yes')"
              >Yes</vs-radio
            >
            <vs-radio
              v-model="issuer.activeRulesCheck"
              vs-name="rule"
              vs-value="No"
              class="m-5"
              @change="updateRule('No')"
              >No</vs-radio
            >
          </vs-row>
          <vs-row
            :key="index"
            v-for="(rule, index) in issuer.activeRules"
            :style="{
              display: issuer.activeRulesCheck == 'No' ? 'none' : 'block',
            }"
          >
            <vs-col
              vs-lg="6"
              vs-sm="12"
              class="ruleOptionContainer px-3 pl-5"
              vs-justify="flex-start"
              style="width: 100px; overflow: hidden"
            >
              <div class="my-2">Active Rule {{ index + 1 }}</div>
              <div id="issrList">
                <select
                  v-model="issuer.activeRules[index].rule"
                  class="w-full posSelect p-3"
                >
                  <option
                    v-for="option in modifiedList"
                    v-bind:value="option._id"
                  >
                    {{ option.rule }}
                  </option>
                </select>
              </div>
            </vs-col>
            <vs-col vs-lg="3" vs-sm="6">
              <div class="my-2 ml-5">Effective Dates</div>
              <Datepicker
                v-model="issuer.activeRules[index].effectiveDate"
                wrapper-class="p-5 mt-0 pt-0"
                calendar-class="posCalendar"
                placeholder="MM/DD/YYYY"
                format="MM/dd/yyyy"
              />
            </vs-col>
            <vs-col vs-lg="3" vs-sm="6" v-if="issuer.activeRules.length > 1">
              <div
                class="flex flex-wrap-reverse items-center ml-6 cursor mt-5 pl-6 pt-6"
                @click="issuer.activeRules.splice(index, 1)"
              >
                <MinusSquareIcon color="white" />
                <div class="addCardFont font-semibold ml-3 cursor">Remove</div>
              </div>
            </vs-col>
          </vs-row>
          <div
            :style="{
              display: issuer.activeRulesCheck == 'No' ? 'none' : 'block',
            }"
          >
            <div
              class="flex flex-wrap-reverse items-center ml-4 cursor"
              @click="addNewRule"
            >
              <PlusSquareIcon color="white" />
              <h5 class="ml-2 mt-1 cursor">Add Rule</h5>
            </div>
          </div>
          <vs-row vs-justify="flex-end">
            <vs-button class="mr-5 mb-3 issuerBtn" @click="addNewIssuer"
              >Add</vs-button
            >
          </vs-row>
        </vs-row>
      </vs-popup>
      <vs-popup class="holamundo" title="Result" :active.sync="addIssuerStatus">
        <h5>Issuer Added Successfully</h5>
      </vs-popup>
      <vs-popup
        class="holamundo"
        title="Active Rules"
        :active.sync="issuerRulesStatus"
      >
        <vs-row class="p-5">
          <vs-col>
            <vs-row class="p-5 pl-2 borderB">
              <div
                class="issuerCircle mb-1"
                :style="{ 'background-color': issuerDetailsforRules.color }"
              ></div>
              <div class="mb-4 ml-4 font-semibold">
                {{ issuerDetailsforRules.name }}
              </div>
            </vs-row>
          </vs-col>
        </vs-row>
        <vs-row class="p-5">
          <vs-row
            v-if="
              issuerDetailsforRules.activeRules &&
              issuerDetailsforRules.activeRules.length > 0
            "
          >
            <vs-row class="mb-2">
              <img
                :src="require('@/assets/images/active-rules/scale.png')"
                class="rulesIcon mr-2"
              />
              <p>Active Rules</p>
            </vs-row>
            <div class="ml-6 rulesContainer">
              <div
                class="my-2 mb-3 ml-1 whiteText"
                :key="index"
                v-for="(rule, index) in issuerDetailsforRules.activeRules"
              >
                <div class="font-semibold">{{ rule.name }}</div>
                <div>{{ rule.description }}</div>
              </div>
            </div>
          </vs-row>
        </vs-row>
        <vs-row
          v-if="
            issuerDetailsforRules.activeRules &&
            issuerDetailsforRules.activeRules.length == 0
          "
        >
          <p class="ml-6 mb-3">No Active Rules</p>
        </vs-row>
      </vs-popup>

      <vs-popup
        class="holamundo addIssuer"
        title="Edit Issuer"
        :active.sync="showEditIssuer"
      >
        <vs-row vs-justify="space-between" class="p-5">
          <vs-col vs-lg="8" vs-sm="12" id="issuerName">
            <vs-row>
              <div class="ml-1 my-1">
                Issuer Name
                <span v-if="errors.issuerName.success" class="sterik">*</span>
                <span v-if="!errors.issuerName.success" else>*</span>
              </div>
            </vs-row>
            <vs-input
              placeholder="Issuer Name"
              v-model="editIssuerInfo.name"
              :danger="errors.issuerName.success"
              :danger-text="errors.issuerName.msg"
              @input="validateIssuerName($event)"
              maxLength="30"
              class="w-full"
              @keydown="$event.keyCode === 69 ? $event.preventDefault() : false"
            />
          </vs-col>
          <vs-col vs-lg="4" vs-sm="12" v-if="showEditIssuer">
            <div class="my-1 marginl-0 pl-0">Issuer Color</div>
            <div
              id="issrDrop"
              class="dropbtn marginl-0 mt-1"
              @click="toggleColorListEdit = !toggleColorListEdit"
              v-on-clickaway="closeColorList"
              :style="{ 'background-color': editIssuerInfoColor }"
            ></div>
            <div id="issrDrop" class="dropdown mt-1 pl-0">
              <div class="dropdown-content" v-show="toggleColorListEdit">
                <div
                  class="colorItemContainer"
                  @click="editIssuerInfoColor = issr.color"
                  :key="index"
                  v-for="(issr, index) in issuersList"
                >
                  <div
                    class="colorIconStyle"
                    :style="{ 'background-color': issr.color }"
                  ></div>
                  <span class="colorTextStyle">{{ issr.name }}</span>
                </div>
              </div>
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="">
          <vs-row>
            <vs-col vs-lg="3" vs-sm="3" class="pl-2">
              <div class="my-1 ml-0 pl-4">Bonus Time (Days)</div>
              <vs-input-number
                v-model="editIssuerInfo.bonus_time"
                class="inline-flex m-6"
                min="0"
              />
            </vs-col>
            <vs-col vs-lg="3" vs-sm="3">
              <div class="my-1 ml-0 pl-4">Grace Time (Days)</div>
              <vs-input-number
                v-model="editIssuerInfo.grace_time"
                class="inline-flex m-6"
                min="0"
              />
            </vs-col>
          </vs-row>
          <vs-row>
            <h3 class="p-5 pb-2">Active Rules</h3>
          </vs-row>
          <vs-row>
            <p class="p-5">Do you want to add active rules for this Issuer?</p>
            <!-- <p class="p-5" v-if="modifiedList && modifiedList.length == 0">No active rules available for this Issuer</p> -->
          </vs-row>
          <vs-row>
            <vs-row v-if="errors.rules.success">
              <p class="p-5 py-3 dangerColor">{{ errors.rules.msg }}</p>
            </vs-row>
            <vs-row>
              <vs-radio
                v-model="editIssuerInfo.active_rules_check"
                vs-name="updateRule"
                vs-value="Yes"
                class="m-5"
                @change="updateRuleForEdit('Yes')"
                >Yes</vs-radio
              >
              <vs-radio
                v-model="editIssuerInfo.active_rules_check"
                vs-name="updateRule"
                vs-value="No"
                class="m-5"
                @change="updateRuleForEdit('No')"
                >No</vs-radio
              >
            </vs-row>
            <vs-row
              :key="index"
              v-for="(rule, index) in editIssuerInfo.activeRules"
              v-bind:class="{
                hidder: editIssuerInfo.active_rules_check == 'No',
              }"
            >
              <vs-col
                vs-lg="6"
                vs-sm="12"
                class="ruleOptionContainer px-3 pl-4"
                vs-justify="flex-start"
              >
                <div class="my-2 ml-1">Active Rule {{ index + 1 }}</div>
                <select
                  v-model="editIssuerInfo.activeRules[index]._id"
                  class="w-full posSelect p-3"
                >
                  <option
                    v-for="option in modifiedList"
                    v-bind:value="option._id"
                    :key="option._id"
                  >
                    {{ option.rule }}
                  </option>
                </select>
              </vs-col>
              <vs-col vs-lg="3" vs-sm="6">
                <div class="my-2 ml-5">Effective Dates</div>
                <Datepicker
                  v-model="editIssuerInfo.activeRules[index].effectiveDate"
                  wrapper-class="p-5 mt-0 pt-0"
                  calendar-class="posCalendar"
                  placeholder="MM/DD/YYYY"
                  format="MM/dd/yyyy"
                />
              </vs-col>
              <vs-col
                vs-lg="3"
                vs-sm="6"
                v-if="editIssuerInfo.activeRules.length > 1"
              >
                <div
                  class="flex flex-wrap-reverse items-center ml-6 cursor mt-5 pl-6 pt-6"
                  @click="editIssuerInfo.activeRules.splice(index, 1)"
                >
                  <MinusSquareIcon color="white" />
                  <div class="addCardFont font-semibold ml-3 cursor">
                    Remove
                  </div>
                </div>
              </vs-col>
            </vs-row>
            <vs-row
              :class="{ hidder: editIssuerInfo.active_rules_check == 'No' }"
            >
              <div
                class="flex flex-wrap-reverse items-center ml-5 cursor"
                @click="addNewRuleForEdit"
              >
                <PlusSquareIcon color="white" />
                <h5 class="ml-2 mt-1 cursor">Add Rule</h5>
              </div>
            </vs-row>
          </vs-row>
          <vs-row vs-justify="flex-end">
            <vs-button class="mr-5 mb-3 issuerBtn" @click="updateIssuer"
              >Update</vs-button
            >
          </vs-row>
        </vs-row>
      </vs-popup>
      <vs-popup
        class="holamundo"
        title="Edit Issuer"
        :active.sync="editIssuerStatus"
      >
        <h5>Issuer Updated Successfully</h5>
      </vs-popup>
      <vs-popup class="holamundo" title="Status" :active.sync="cardAddStatus">
        <h5>Card Added Successfully</h5>
      </vs-popup>
      <vs-popup class="holamundo" title="Status" :active.sync="cardEditStatus">
        <h5>Card Edited Successfully</h5>
      </vs-popup>
      <vs-popup
        class="holamundo"
        title="Status"
        :active.sync="cardApproveStatus"
      >
        <h5>Card Approved Successfully</h5>
      </vs-popup>
      <vs-popup
        class="holamundov"
        title="Status"
        :active.sync="showDeleteStatus.status"
      >
        <h5>{{ showDeleteStatus.msg }}</h5>
      </vs-popup>
      <vs-popup
        class="holamundov"
        title="Status"
        :active.sync="showExistingUsersStatus.status"
      >
        <h5>{{ showExistingUsersStatus.msg }}</h5>
        <!-- <h6 class="my-3">Users are:</h6> -->
        <div
          class="mt-2"
          style="max-height: 300px"
          v-if="existingUsers.length > 0"
        >
          <div v-for="(data, index) in existingUsers" :key="index" class="my-1">
            {{
              data.user
                ? index +
                  1 +
                  " - " +
                  data.user.firstname +
                  " " +
                  data.user.lastname
                : ""
            }}
          </div>
        </div>
      </vs-popup>
      <vs-popup class="holamundo" title="Status" :active.sync="confirmDelete">
        <h5>Are you sure that you want to delete?</h5>
        <vs-row vs-justify="flex-end">
          <vs-button @click="deleteCards" class="mr-4">Yes</vs-button>
          <vs-button @click="confirmDelete = false">No</vs-button>
        </vs-row>
      </vs-popup>
      <vs-popup
        class="holamundo"
        title="Status"
        :active.sync="confirmIssuerDelete"
      >
        <h5>Are you sure that you want to delete?</h5>
        <vs-row vs-justify="flex-end">
          <vs-button @click="deleteIssuer" class="mr-4">Yes</vs-button>
          <vs-button @click="confirmIssuerDelete = false">No</vs-button>
        </vs-row>
      </vs-popup>
    </vs-row>
  </div>
</template>

<script>
import {
  PlusSquareIcon,
  UploadCloudIcon,
  EyeIcon,
  MinusSquareIcon,
} from "vue-feather-icons";
import { mixin as clickaway } from "vue-clickaway";
import Datepicker from "vuejs-datepicker";
import vueMultiSelect from "vue-multi-select";
import EventBus from "@/event-bus.js";
import {
  validateIssuerName,
  onSubmitIssuer,
  validateRuleEffectiveDate,
  validateAlphaNumeric,
  validateRules,
} from "@/views/admin/validation";
import VueLoadImage from "vue-load-image";

import { genericErrorMessage, toast } from "@/keys/toast-messages";

export default {
  mixins: [clickaway],
  components: {
    PlusSquareIcon,
    UploadCloudIcon,
    MinusSquareIcon,
    Datepicker,
    vueMultiSelect,
    VueLoadImage,
  },
  data() {
    return {
      existingUsers: [],
      confirmDelete: false,
      confirmIssuerDelete: false,
      deleteIssuerId: "",

      options: [
        "Select option",
        "options",
        "selected",
        "mulitple",
        "label",
        "searchable",
        "clearOnSelect",
        "hideSelected",
        "maxHeight",
        "allowEmpty",
        "showLabels",
        "onChange",
        "touched",
      ],
      actionBtnClr: "#1D2024",
      showAddIssuer: false,
      showEditIssuer: false,

      primaryColor: "#4B4BF9",
      newRuleCheck: "Yes",
      showDetails: false,
      toggleColorList: false,
      toggleColorListEdit: false,

      toggleRulesList: false,

      bgc: {
        backgroundColor: "#4B4BF9",
      },
      cardsList: [],
      cardInfo: "",

      selected: [],
      itemsPerPage: 4,

      issuer: {
        name: "",
        color: "#4B4BF9",
        photo: "",
        activeRules: [],
        activeRulesCheck: "No",
        bonus_time: 25,
        grace_time: 0,
      },

      ruleItem: [{ text: "Rule Name & Description", value: "rule" }],
      rulesList: [],

      addIssuerStatus: false,
      issuersList: [],

      issuerRulesStatus: false,
      issuerDetailsforRules: "",

      editIssuerStatus: false,
      editIssuerInfo: {
        activeRulesCheck: "No",
        bonus_time: 25,
        grace_time: 0,
      },
      editIssuerInfoColor: "#fafafa",

      showDeleteStatus: {
        msg: "",
        status: false,
      },
      showExistingUsersStatus: {
        msg: "",
        status: false,
      },

      cardAddStatus: false,
      cardEditStatus: false,
      cardApproveStatus: false,

      errors: {
        issuerName: {
          msg: "",
          success: false,
        },
        rules: {
          msg: "",
          success: false,
        },
      },
      validateIssuerName,
      onSubmitIssuer,
      validateRuleEffectiveDate,
      validateAlphaNumeric,
      validateRules,

      modifiedList: [],
      genericErrorMessage,
      toast,
    };
  },
  methods: {
    deleteIssr(id) {
      this.deleteIssuerId = id;
      this.confirmIssuerDelete = true;
    },
    calculateRulesWidth() {
      this.modifiedList = this.rulesList;
      // this.modifiedList = [];
      // let maxLength = 80;
      // for(var i = 0; i < this.rulesList.length ; i++){
      //     this.modifiedList[i] = {
      //             rule: '',
      //             _id: ''
      //         }
      //     if(this.rulesList[i].rule.length > maxLength){
      //         this.modifiedList[i] = {
      //             rule: this.rulesList[i].rule.substr(0, maxLength) + '...',
      //             _id: this.rulesList[i]._id
      //         }
      //     }
      //     else {
      //          this.modifiedList[i] = {
      //             rule: this.rulesList[i].rule,
      //             _id: this.rulesList[i]._id
      //         }
      //     }
      // }
    },
    async editIssuer(data) {
      data.cards[0].issuer_detail[0].active_rules_check =
        data.cards[0].issuer_detail[0].activeRulesCount > 0 ? "Yes" : "No";
      this.editIssuerInfo = data.cards[0].issuer_detail[0];
      this.editIssuerInfo.activeRules = data.cards[0].rulesDetails;
      this.editIssuerInfo.bonus_time = data.cards[0].issuer_detail[0].bonus_time
        ? data.cards[0].issuer_detail[0].bonus_time
        : 25;
      this.editIssuerInfo.grace_time = data.cards[0].issuer_detail[0].grace_time
        ? data.cards[0].issuer_detail[0].grace_time
        : 0;
      // this.editIssuerInfo.activeRules = await this.editIssuerInfo.activeRules.filter(function(value, index){
      //     value.effectiveDate = value.effectiveDate ? value.effectiveDate : new Date();
      //     value.rule = value.rule._id;
      //     return value.rule ? value : null;
      // });
      this.editIssuerInfoColor = data.cards[0].issuer_detail[0].color;
      this.showEditIssuer = true;
      (this.errors = {
        issuerName: {
          msg: "",
          success: false,
        },
        rules: {
          msg: "",
          success: false,
        },
      }),
        this.getIssuers();
      this.getRules();
      // this.getRules(this.editIssuerInfo._id);
    },
    setIssuerRuleStatus(data) {
      this.issuerRulesStatus = true;
      this.issuerDetailsforRules = {
        name: data._id[0],
        color: data.cards[0].issuer_detail[0].color,
        activeRules: data.cards[0].rulesDetails,
      };
    },
    async editCard(cardInfo) {
      if (cardInfo) {
        await this.closeDetails();
        await this.$router.push({
          name: "edit-card",
          params: {
            card: cardInfo,
            up: this.cardInfo.upgrade_card,
            down: this.cardInfo.downgrade_card,
            pro: this.cardInfo.product_change,
          },
        });
      } else {
        await this.$router.push({ path: "/view-cards/add-card" });
      }
    },
    closeDetails() {
      this.showDetails = false;
    },
    addNewRule() {
      this.issuer.activeRules.push({ rule: "", effectiveDate: "" });
    },
    addNewRuleForEdit() {
      this.editIssuerInfo.activeRules.push({ rule: "", effectiveDate: "" });
    },
    showFilePath() {
      this.issuer.photo = this.$refs.uploadAddIssuer.files[0];
    },
    selectedColor(color) {
      this.bgc.backgroundColor = color;
      this.toggleColorList = false;
      this.issuer.color = color;
    },
    closeColorList() {
      this.toggleColorList = false;
      this.toggleColorListEdit = false;
    },
    closeRulesList() {
      this.toggleRulesList = false;
    },
    updateRule(rule) {
      this.issuer.activeRulesCheck = rule;
    },
    updateRuleForEdit(rule) {
      // this.editIssuerInfo.active_rules_check = rule;
      this.$set(
        this.editIssuerInfo,
        this.editIssuerInfo.active_rules_check,
        rule
      );
    },
    addNewData() {
      (this.issuer = {
        name: "",
        color: "#6B292B",
        photo: "",
        activeRules: [],
        activeRulesCheck: "No",
        bonus_time: 25,
        grace_time: 0,
      }),
        (this.showAddIssuer = true);
      (this.errors = {
        issuerName: {
          msg: "",
          success: false,
        },
        rules: {
          msg: "",
          success: false,
        },
      }),
        (this.toggleColorList = false);
      this.getIssuers();
      this.getRules();
    },
    viewDetails(rowId) {
      this.getCardInfo(rowId);
    },
    async deleteCards() {
      this.confirmDelete = false;
      if (this.selected.length == 0) {
        this.showDeleteStatus = {
          msg: "Please select atleast one card to delete",
          status: true,
        };
      } else {
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        this.showDeleteStatus = {
          msg: "",
          status: false,
        };
        let cardIds = [];
        await this.selected.forEach(async function (item, index) {
          await item.forEach(function (element, index) {
            cardIds.push(element._id);
          });
        });

        return new Promise((resolve, reject) => {
          this.$axios
            .post(
              this.$ApiKeys.BASE_URL + this.$EndPoints.DeleteCards,
              {
                cardId: cardIds,
              },
              {
                headers: {
                  Authorization: this.$localStorage.get("token"),
                },
              }
            )
            .then(async (res) => {
              this.$vs.loading.close();
              if (res.data.success == true) {
                this.showDeleteStatus = {
                  msg: res.data.data.message,
                  status: true,
                };
                this.getCards();
              } else {
                this.toast(this.genericErrorMessage());
              }
            })
            .catch((e) => {
              this.$vs.loading.close();
              if (e.response.data.error && e.response.data.error.cards) {
                this.showExistingUsersStatus = {
                  msg: e.response.data.error.cards,
                  status: true,
                };
                this.existingUsers = e.response.data.data;
              } else {
                this.showExistingUsersStatus = {
                  msg: "",
                  status: false,
                };
                this.existingUsers = [];
              }
              if (e.response.data.errors && e.response.data.errors.cardId) {
                this.showDeleteStatus = {
                  msg: e.response.data.errors.cardId,
                  status: true,
                };
              } else {
                this.showDeleteStatus = {
                  msg: "",
                  status: false,
                };
              }
              if (
                !e.response.data.error &&
                !e.response.data.error.cards &&
                !e.response.data.errors.cardId
              ) {
                if (e.response.status !== 401) {
                  this.toast(this.genericErrorMessage());
                }
              }
            });
        });
      }
    },
    async updateIssuer() {
      if (this.onSubmitIssuer("update")) {
        let rules = [];
        await this.editIssuerInfo.activeRules.forEach(function (value, index) {
          if (value._id) {
            rules.push({
              rule: value._id,
              effectiveDate: value.effectiveDate
                ? value.effectiveDate
                : new Date(),
            });
          }
        });
        this.validateRules(
          rules.length,
          this.editIssuerInfo.active_rules_check
        );
        if (!this.errors.rules.success) {
          this.$vs.loading({
            background: "rgba(1,2,3,.2)",
          });
          return new Promise((resolve, reject) => {
            this.$axios
              .post(
                this.$ApiKeys.BASE_URL + this.$EndPoints.EditIssuer,
                {
                  issuerId: this.editIssuerInfo._id,
                  name: this.editIssuerInfo.name,
                  color: this.editIssuerInfoColor,
                  activeRules:
                    this.editIssuerInfo.active_rules_check == "Yes"
                      ? rules
                      : [],
                  active_rules_check:
                    this.editIssuerInfo.active_rules_check == "Yes"
                      ? true
                      : false,
                  bonus_time: this.editIssuerInfo.bonus_time,
                  grace_time: this.editIssuerInfo.grace_time,
                },
                {
                  headers: {
                    Authorization: this.$localStorage.get("token"),
                  },
                }
              )
              .then(async (res) => {
                this.$vs.loading.close();
                if (res.data.success == true) {
                  (this.editIssuerInfo = {
                    _id: "",
                    name: "",
                    activeRules: [],
                    activeRulesCheck: "Yes",
                  }),
                    (this.editIssuerInfoColor = "#fafafa"),
                    this.getCards();
                  this.editIssuerStatus = true;
                  this.showEditIssuer = false;
                } else {
                  this.toast(this.genericErrorMessage());
                }
              })
              .catch((e) => {
                if (e.response.data.errors.duplicateRules) {
                  this.errors.rules = {
                    msg: e.response.data.errors.duplicateRules,
                    success: true,
                  };
                } else {
                  this.errors.rules = {
                    msg: "",
                    success: false,
                  };
                  if (e.response.status !== 401) {
                    this.toast(this.genericErrorMessage());
                  }
                }
                this.$vs.loading.close();
                // console.log("Error in updateIssuer: ",e.response);
              });
          });
        }
      }
    },
    async addNewIssuer() {
      if (this.onSubmitIssuer("add")) {
        this.issuer.activeRules = await this.issuer.activeRules.filter(
          function (value, index) {
            value.effectiveDate = value.effectiveDate
              ? value.effectiveDate
              : new Date();
            return value.rule ? value : null;
          }
        );

        this.validateRules(
          this.issuer.activeRules.length,
          this.issuer.activeRulesCheck
        );

        if (!this.errors.rules.success) {
          this.$vs.loading({
            background: "rgba(1,2,3,.2)",
          });
          return new Promise((resolve, reject) => {
            this.$axios
              .post(
                this.$ApiKeys.BASE_URL + this.$EndPoints.AddIssuer,
                {
                  name: this.issuer.name,
                  color: this.issuer.color,
                  activeRules:
                    this.issuer.activeRulesCheck == "Yes"
                      ? this.issuer.activeRules
                      : [],
                  active_rules_check:
                    this.issuer.activeRulesCheck == "Yes" ? true : false,
                  bonus_time: this.issuer.bonus_time,
                  grace_time: this.issuer.grace_time,
                },
                {
                  headers: {
                    Authorization: this.$localStorage.get("token"),
                  },
                }
              )
              .then(async (res) => {
                this.$vs.loading.close();
                if (res.data.success == true) {
                  this.addIssuerStatus = true;
                  this.showAddIssuer = false;
                  this.getCards();
                  this.issuer = {
                    name: "",
                    color: "#4B4BF9",
                    photo: "",
                    activeRules: [],
                    activeRulesCheck: "Yes",
                  };
                } else {
                  this.toast(this.genericErrorMessage());
                }
              })
              .catch((e) => {
                this.$vs.loading.close();
                if (e.response.data.errors.name) {
                  this.errors.issuerName = {
                    msg: e.response.data.errors.name,
                    success: true,
                  };
                } else {
                  this.errors.issuerName = {
                    msg: "",
                    success: false,
                  };
                }
                if (e.response.data.errors.duplicateRules) {
                  this.errors.rules = {
                    msg: e.response.data.errors.duplicateRules,
                    success: true,
                  };
                } else {
                  this.errors.rules = {
                    msg: "",
                    success: false,
                  };
                }
                if (
                  !e.response.data.errors.name &&
                  !e.response.data.errors.duplicateRules
                ) {
                  if (e.response.status !== 401) {
                    this.toast(this.genericErrorMessage());
                  }
                }
              });
          });
        }
      }
    },
    getCards() {
      this.$vs.loading({
        background: "rgba(1,2,3,.2)",
      });
      return new Promise((resolve, reject) => {
        this.$axios
          .get(this.$ApiKeys.BASE_URL + this.$EndPoints.ViewCards, {
            params: {
              page: 1,
            },
            headers: {
              Authorization: this.$localStorage.get("token"),
            },
          })
          .then(async (res) => {
            this.$vs.loading.close();
            if (res.data.success) {
              if (this.$route.params.add) {
                this.cardAddStatus = this.$route.params.add;
                this.$route.params.add = false;
              } else if (this.$route.params.edit) {
                this.cardEditStatus = this.$route.params.edit;
                this.$route.params.edit = false;
              } else if (this.$route.params.approve) {
                this.cardApproveStatus = this.$route.params.approve;
                this.$route.params.approve = false;
                this.$root.$emit("updateApprovals", {});
              }
              resolve((this.cardsList = res.data.data));
              for (var i = 0; i < res.data.data.length; i++) {
                this.selected[i] = [];
              }
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            if (this.$route.params.add) {
              this.cardAddStatus = this.$route.params.add;
              this.$route.params.add = false;
            } else if (this.$route.params.edit) {
              this.cardEditStatus = this.$route.params.edit;
              this.$route.params.edit = false;
            } else if (this.$route.params.approve) {
              this.cardApproveStatus = this.$route.params.approve;
              this.$route.params.approve = false;
              this.$root.$emit("updateApprovals", {});
            }
            // console.log("Error in getCards: ",e);
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
            this.$vs.loading.close();
          });
      });
    },
    getCardInfo(id) {
      this.$vs.loading({
        background: "rgba(1,2,3,.2)",
      });
      return new Promise((resolve, reject) => {
        this.$axios
          .post(this.$ApiKeys.BASE_URL + this.$EndPoints.CardInfo, {
            cardId: id,
            headers: {
              Authorization: this.$localStorage.get("token"),
            },
          })
          .then(async (res) => {
            this.$vs.loading.close();
            if (res.data.success) {
              this.showDetails = true;
              resolve((this.cardInfo = res.data.data));
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            this.$vs.loading.close();
            // console.log('Error in getCardInfo: ',e);
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
          });
      });
    },
    getIssuers() {
      return new Promise(async (resolve, reject) => {
        await this.$axios
          .get(this.$ApiKeys.BASE_URL + this.$EndPoints.IssuerColors, {
            params: {
              color: true,
            },
            headers: {
              Authorization: this.$localStorage.get("token"),
            },
          })
          .then(async (res) => {
            if (res.data.success) {
              resolve((this.issuersList = res.data.data));
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
          });
      });
    },
    getRules(id) {
      this.$vs.loading({
        background: "rgba(1,2,3,.2)",
      });
      return new Promise(async (resolve, reject) => {
        await this.$axios
          .get(this.$ApiKeys.BASE_URL + this.$EndPoints.GetRules, {
            params: {
              issuerId: id ? id : "",
            },
            headers: {
              Authorization: this.$localStorage.get("token"),
            },
          })
          .then(async (res) => {
            this.$vs.loading.close();
            if (res.data.success) {
              resolve((this.rulesList = res.data.data));
              await this.calculateRulesWidth();
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            this.$vs.loading.close();
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
          });
      });
    },
    deleteIssuer() {
      this.confirmIssuerDelete = false;
      this.$vs.loading({
        background: "rgba(1,2,3,.2)",
      });
      return new Promise(async (resolve, reject) => {
        await this.$axios
          .post(
            this.$ApiKeys.BASE_URL + this.$EndPoints.DeleteIssuer,
            {
              issuerId: this.deleteIssuerId,
            },
            {
              headers: {
                Authorization: this.$localStorage.get("token"),
              },
            }
          )
          .then(async (res) => {
            this.$vs.loading.close();
            if (res.data.success) {
              if (res.data.data.message) {
                this.showDeleteStatus = {
                  msg: res.data.data.message,
                  status: true,
                };
              } else {
                this.showDeleteStatus = {
                  msg: "",
                  status: false,
                };
              }
              resolve();
              this.getCards();
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            this.$vs.loading.close();
            if (e.response.data.error && e.response.data.error.cards) {
              this.showExistingUsersStatus = {
                msg: e.response.data.error.cards,
                status: true,
              };
              this.existingUsers = e.response.data.data;
            } else {
              this.showExistingUsersStatus = {
                msg: "",
                status: false,
              };
              this.existingUsers = [];
              if (e.response.status !== 401) {
                this.toast(this.genericErrorMessage());
              }
            }
          });
      });
    },
  },
  created() {
    EventBus.$emit("resetToggleGroup", true);
    this.getCards();
  },
};
</script>

<style>
@import "./style.css";
</style>































